import { render, staticRenderFns } from "./ValidationCard.vue?vue&type=template&id=0fda5fdf"
import script from "./ValidationCard.vue?vue&type=script&lang=js"
export * from "./ValidationCard.vue?vue&type=script&lang=js"
import style0 from "./ValidationCard.vue?vue&type=style&index=0&id=0fda5fdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports